// src/components/AddUserModal.jsx

import React, { useState, useContext } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';
import { AuthContext } from '../../context/AuthContext';
import { useIntl } from 'react-intl';

export default function AddUserModal({ onClose, onUserAdded }) {
  const intl = useIntl();
  const { user } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    cpf: '',
    creci: '',
    whatsapp: '',
    role: 'editor' // default
  });

  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const newUser = {
        ...formData,
        accountType: user?.accountType || '',
        parentId: user?.uid || null,
        photoURL: user?.photoURL || null,
        createdAt: serverTimestamp(),
        active: true
      };

      const docRef = await addDoc(collection(db, 'users'), newUser);
      onUserAdded({ id: docRef.id, ...newUser });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        onClose();
      }, 1500);
    } catch (error) {
      console.error('Erro ao adicionar usuário:', error);
    }

    setSaving(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{intl.formatMessage({ id: 'user.addTitle', defaultMessage: 'Adicionar Novo Usuário' })}</h2>

        <p className="info-message">
          {intl.formatMessage({ id: 'user.addUserInfo', defaultMessage: 'Preencha os dados do novo corretor abaixo.' })}
        </p>

        <form className="modal-form" onSubmit={handleSubmit}>
          <label>{intl.formatMessage({ id: 'form.name', defaultMessage: 'Nome' })}</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label>{intl.formatMessage({ id: 'user.email', defaultMessage: 'Email' })}</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label>CPF</label>
          <input
            name="cpf"
            value={formData.cpf}
            onChange={handleChange}
          />

          <label>CRECI (e.g., SP-12345F)</label>
          <input
            name="creci"
            value={formData.creci}
            onChange={handleChange}
          />

          <label>WhatsApp (opcional)</label>
          <input
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            placeholder="+55 11 91234-5678"
          />

          <label>Tipo de Usuário</label>
          <select name="role" value={formData.role} onChange={handleChange}>
            <option value="editor">Editor</option>
            <option value="corretor">Corretor</option>
          </select>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-btn">
              {intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancelar' })}
            </button>
            <button type="submit" className="save-btn" disabled={saving}>
              {saving
                ? intl.formatMessage({ id: 'general.saving', defaultMessage: 'Salvando...' })
                : intl.formatMessage({ id: 'general.save', defaultMessage: 'Salvar' })}
            </button>
          </div>

          {success && <p className="success-message">{intl.formatMessage({ id: 'saveSuccess', defaultMessage: 'Salvo com sucesso!' })}</p>}
        </form>
      </div>
    </div>
  );
}
